import React from 'react'

const Footer = () => {
  return (
    <div>
        <div className="mt-10 py-10 border-t md:text-center">
           
        </div>
    </div>
  )
}

export default Footer